import React from 'react';
import './LegalPages.css';

const Careers = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Careers</h1>
        <p className="last-updated">Join Our Team</p>
        
        <section>
          <h2>Work With Us</h2>
          <p>
            At Prangio Designs, we're always looking for talented individuals who share our passion for creating exceptional spaces. 
            We believe in fostering creativity, innovation, and professional growth in a collaborative environment.
          </p>
          
          <h3>What We Offer</h3>
          <ul>
            <li>Competitive compensation packages</li>
            <li>Opportunities to work on diverse and exciting projects</li>
            <li>Professional development and learning opportunities</li>
            <li>Collaborative and creative work environment</li>
            <li>Flexible working arrangements</li>
          </ul>
        </section>

        <section>
          <h2>Current Opportunities</h2>
          <p>
            We're currently building our team and evaluating new opportunities. 
            <strong> Please check back later for available positions.</strong>
          </p>
          
          <p>
            In the meantime, we encourage talented architects, interior designers, and creative professionals 
            to connect with us. We're always interested in meeting passionate individuals who could be a 
            great fit for our team.
          </p>
        </section>

        <section>
          <h2>Get In Touch</h2>
          <p>
            Even if there are no current openings, we'd love to hear from you. Send us your portfolio 
            and tell us about your passion for design.
          </p>
          
          <div className="contact-details">
            <p><strong>Prangio Designs Pte. Ltd.</strong></p>
            <p>21/22, Alandur Road, WeWork Olympia Cyberspace</p>
            <p>Arulayiammanpet, 2nd Street, Guindy, Chennai 600032</p>
            <p>Email: prangiodesigns@gmail.com</p>
            <p>Phone: +91 (776) 003-4934</p>
            <p><em>Subject: Career Opportunities</em></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Careers;
